export default "__VITE_ASSET__ab1703a3__"